/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { safeRest, noop } from '../../../utils/functions.js';
import handle from '../../../utils/handle.js';
import { MenuItemWrapper, MenuItemComponent } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../../hooks/useTheme.js';

var _excluded = ["id", "label", "isSelected", "onClick"];
var MenuItem = function MenuItem(_ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === undefined ? false : _ref$isSelected,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === undefined ? noop : _ref$onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var safeProps = safeRest(rest);
  return /*#__PURE__*/jsx(MenuItemWrapper, {
    role: "none",
    theme: theme,
    children: /*#__PURE__*/jsx(MenuItemComponent, _objectSpread(_objectSpread({
      id: id,
      role: "menuitem",
      theme: theme,
      onClick: handle(onClick),
      $isSelected: isSelected
    }, safeProps), {}, {
      children: label
    }))
  });
};
process.env.NODE_ENV !== "production" ? MenuItem.propTypes = {
  /** id for the DOM element */
  id: PropTypes.string,
  /** label displayed on menu item */
  label: PropTypes.node.isRequired,
  /** flag for currently selected MenuItem */
  isSelected: PropTypes.bool,
  /** onClick handler for menu item */
  onClick: PropTypes.func
} : undefined;
process.env.NODE_ENV !== "production" ? MenuItem.displayName = 'MenuItem' : undefined;

export { MenuItem as default };
